import AlertType from '../../../utils/alertType';

export default {
    show: false,
    messages: [],
    type: AlertType.ALERTA,    
}